import { productUrlPrefix } from './url-utils';

export const gameRulesUrl = ({ product }) =>
  `${productUrlPrefix(product)}/rules`;
